import { KeyboardEvent, useRef, useState } from 'react'

import RoundedButton from 'components/Atoms/Buttons/RoundedButton/RoundedButton'
import Input from 'components/Atoms/Calculator/Input'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

interface FourthStepPassengerProps {
  onCalculate: (days: number, distance: number) => void
}

export default function FourthStepPassenger({
  onCalculate,
}: FourthStepPassengerProps) {
  const { t } = useTranslation('calculator')

  const [daysInput, setDaysInput] = useState('')
  const [distanceInput, setDistanceInput] = useState('')

  // refs para mover el foco con Enter
  const daysRef = useRef<HTMLInputElement | null>(null)
  const distanceRef = useRef<HTMLInputElement | null>(null)

  const handleCalculateClick = () => {
    const parsedDays = parseInt(daysInput, 10)
    const days = Number.isNaN(parsedDays) ? 0 : parsedDays

    const parsedDistance = parseFloat(distanceInput.replace(',', '.'))
    const distance = Number.isNaN(parsedDistance) ? 0 : parsedDistance

    if (days <= 0 || distance <= 0) {
      toast.error(t('calculator.rightColumn.errors.completeAllFields'), {
        theme: 'colored',
      })
      return
    }

    onCalculate(days, distance)
  }

  const handleKeyDownDays = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      distanceRef.current?.focus()
    }
  }

  const handleKeyDownDistance = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      handleCalculateClick()
    }
  }

  return (
    <div className="h-full flex flex-col justify-end">
      <div className="h-full flex flex-col justify-between max-sm:gap-6 max-sm:items-center">
        <p>{t('calculator.rightColumn.fourthStep.driver.text')}</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label={t('calculator.rightColumn.fourthStep.driver.labelInput1')}
            placeholder={t(
              'calculator.rightColumn.fourthStep.driver.placeholder1',
            )}
            className="w-48 justify-end"
            value={daysInput}
            onChange={setDaysInput}
            onKeyDown={handleKeyDownDays}
            inputRef={daysRef}
          />
          <Input
            label={t('calculator.rightColumn.fourthStep.driver.labelInput2')}
            placeholder={t(
              'calculator.rightColumn.fourthStep.driver.placeholder2',
            )}
            className="w-48 justify-end"
            value={distanceInput}
            onChange={setDistanceInput}
            onKeyDown={handleKeyDownDistance}
            inputRef={distanceRef}
          />
        </div>
        <RoundedButton onClick={handleCalculateClick}>
          {t('calculator.rightColumn.fourthStep.driver.cta')}
        </RoundedButton>
      </div>
    </div>
  )
}
